import { darken, lighten } from '@material-ui/core'
import {
  getColorErrorSelector,
  getColorPrimarySelector,
  getColorSuccessSelector,
  getColorWarnSelector
} from '@signal/theme/selectors'

// Returns primary color from selector based on string color input.
// Why? Often styled components want to hae the dev input a color string, then
// base all resulting styles off that color, using lighten, darken, alpha, etc.
// This makes it easy to select the main color without using the selectors
// directly over and over again
export function getMainColor(color = 'BASE', theme: object) {
  const sanitizeColor = color.trim().toUpperCase()

  let mainColor = lighten(darken(getColorPrimarySelector()(theme), 0.7), 0.4)

  if (sanitizeColor.includes('GREEN'))
    mainColor = getColorSuccessSelector()(theme)
  if (sanitizeColor.includes('BLUE'))
    mainColor = getColorPrimarySelector()(theme)
  if (sanitizeColor.includes('YELLOW'))
    mainColor = getColorWarnSelector()(theme)
  if (sanitizeColor.includes('RED')) mainColor = getColorErrorSelector()(theme)

  return mainColor
}
